import * as React from 'react';
import { ShareWhatsAppButtonContainer } from './share/ShareWhatsAppButtonContainer';
import { useSelector } from 'react-redux';
import { selectSelectedEntitiesCount } from '../../selectors/selected';
import { RemoveContainer } from './remove/RemoveContainer';
import { PrintContainer } from './print';
import { selectSelectedFolder } from '../../selectors/folders';

export const MassActionsContainer = () => {
  const isSelected = Boolean(useSelector(selectSelectedEntitiesCount));
  const selectedFolder = Boolean(useSelector(selectSelectedFolder));

  return (
    <React.Fragment>
      {isSelected && <ShareWhatsAppButtonContainer />}
      {isSelected && <PrintContainer />}
      {(!selectedFolder || isSelected) && <RemoveContainer />}
    </React.Fragment>
  );
};
